// extracted by mini-css-extract-plugin
export default {"webcamVideo":"WebcamView_webcamVideo__yRTov","dead":"WebcamView_dead__4XMiB"};